if (!customElements.get('split-image-banner-slider')) {
  class SplitImageBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.autoplayDelay = 4000;
      this.intervalId = null;
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.initSlider();
      
      this.resizeListener = () => this.initSlider();
      this.mediaQuery.addEventListener('change', this.resizeListener);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.resizeListener && this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.resizeListener);
      }
    }

    initSlider() {
      this.stopAutoplay();
      
      this.track = this.querySelector('.split-image-banner__slider-track');
      this.slides = this.querySelectorAll('.split-image-banner__slide');
      this.dotsContainer = this.querySelector('.split-image-banner__slider-dots');
      
      if (!this.track || this.slides.length <= 1) return;

      if (this.mediaQuery.matches) {
        // Build dots dynamically
        this.dotsContainer.innerHTML = '';
        this.slides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.className = `split-image-banner__slider-dot${index === 0 ? ' active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => this.goToSlide(index));
          this.dotsContainer.appendChild(dot);
        });

        // Update dots on scroll
        this.scrollListener = () => this.updateActiveDot();
        this.track.addEventListener('scroll', this.scrollListener, { passive: true });

        // Start autoplay
        this.startAutoplay();

        // Autoplay mouse / touch hooks
        this.mouseenterListener = () => this.stopAutoplay();
        this.mouseleaveListener = () => this.startAutoplay();
        this.touchstartListener = () => this.stopAutoplay();
        this.touchendListener = () => this.startAutoplay();

        this.addEventListener('mouseenter', this.mouseenterListener);
        this.addEventListener('mouseleave', this.mouseleaveListener);
        this.addEventListener('touchstart', this.touchstartListener, { passive: true });
        this.addEventListener('touchend', this.touchendListener, { passive: true });
      } else {
        if (this.dotsContainer) this.dotsContainer.innerHTML = '';
        if (this.scrollListener) {
          this.track.removeEventListener('scroll', this.scrollListener);
        }
      }
    }

    updateActiveDot() {
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return;
      const index = Math.round(this.track.scrollLeft / slideWidth);
      if (index !== this.activeIndex) {
        this.activeIndex = index;
        const dots = this.querySelectorAll('.split-image-banner__slider-dot');
        dots.forEach((dot, idx) => {
          dot.classList.toggle('active', idx === this.activeIndex);
        });
      }
    }

    goToSlide(index) {
      if (!this.track) return;
      const slideWidth = this.track.clientWidth;
      this.track.scrollTo({
        left: index * slideWidth,
        behavior: 'smooth'
      });
      this.activeIndex = index;
    }

    startAutoplay() {
      if (!this.mediaQuery.matches) return;
      this.stopAutoplay();
      this.intervalId = setInterval(() => {
        let nextIndex = this.activeIndex + 1;
        if (nextIndex >= this.slides.length) {
          nextIndex = 0;
        }
        this.goToSlide(nextIndex);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }

  customElements.define('split-image-banner-slider', SplitImageBannerSlider);
}
